module.exports = __webpack_public_path__ + "static/media/BasedSwap.f6358f00.png";